<template>
  <div id="devmgpasswd">
    <el-input class="oxiaom_input" placeholder="****" v-model="passwd" show-password>
      <template slot="prepend">旧密码</template>
    </el-input>
    <br />
    <el-input class="oxiaom_input" placeholder="****" v-model="newpass1" show-password>
      <template slot="prepend">新密码</template>
    </el-input>
    <el-input class="oxiaom_input" placeholder="****" v-model="newpass2" show-password>
      <template slot="prepend">新密码</template>
    </el-input>
    <el-button class="oxiaom_input" type="primary" @click="func_changepasswd" round>修改密码</el-button>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
export default {
  data() {
    return {
      passwd: "",
      newpass1: "",
      newpass2: "",
      options: [],
      nodeid: "",
      group_name: "",
      tableData: [],
      dialogVisible_adddevice: false,
      name_adddevice: "",
      seed_adddevice: "",
      seed_ofnode: "",
      tag1: "自定义标签A可选",
      tag2: "自定义标签B可选",
      type: "1",
      device_status: "1",
      sqr_adddevice: "",
      save_backdata: "",
      dialogVisible_save_back: false,
      dialogVisible_save_back_detail: false,
      valueT: [],
      Tdata: [],
      fornodeid: -1,
      forgid: -1
    };
  },
  created() {},
  methods: {
    func_changepasswd() {
      if (this.passwd.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "不能为空",
          showClose: false
        });
        return;
      }
      if (this.newpass1.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "不能为空",
          showClose: false
        });
        return;
      }
      if (this.newpass2.trim() == "") {
        this.$notify.success({
          title: "Info",
          message: "不能为空",
          showClose: false
        });
        return;
      }
      if (
        this.newpass1.trim() == this.newpass2.trim() &&
        this.passwd.trim() == sessionStorage.getItem("passwd")
      ) {
        let data = new FormData();
        data.append("id", sessionStorage.getItem("id"));
        data.append("token", sessionStorage.getItem("token"));
        data.append("newpass", this.newpass1);

        axios
          .post("/user/fnkukei/newpasswdnick", data)
          .then(
            function(res) {
              if (res.data.res) {
                this.$notify.success({
                  title: "Info",
                  message: "密码修改成功",
                  showClose: false
                });
                sessionStorage.setItem("passwd", this.newpass1);
              } else {
                this.$notify.success({
                  title: "Info",
                  message: "密码修改失败",
                  showClose: false
                });
              }
            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          });
      } else {
        this.$notify.success({
          title: "Info",
          message: "密码不相符",
          showClose: false
        });
      }
    }
  }
};
</script>

<style  scoped>
.oxiaom_input {
  width: 300px;
  margin-top: 20px;
}
.el-transfer {
  text-align: left;
}

#devmgpasswd {
  padding: 20px;
  width: 300px;
  margin: 0 auto;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/xiugaimima.vue